import React, {useRef} from 'react'
import {connect} from 'react-redux'
import compose from 'recompose/compose'
import defaultProps from 'recompose/defaultProps'
import withState from 'recompose/withState'
import withHandlers from 'recompose/withHandlers'
import withPropsOnChange from 'recompose/withPropsOnChange'
import GoogleMapReact from 'google-map-react'
import supercluster from 'points-cluster'
import SimpleMarker from './SimpleMarker'
import ClusterMarker from './ClusterMarker'
import {GOOGLE_MAP_API_KEY} from '../../../../../config'
import withGoogleMaps from '../../../../organisms/with-google-maps/withGoogleMaps'
import {withProps} from "recompose";

export function GoogleMap(props) {
  const {setMapBounds, itemMap, selectedIds} = props;

  const map = useRef(null);
  const boundsChange = (boundsEvent) => {
    props.onChange(boundsEvent);
    if(setMapBounds){
      setMapBounds(boundsEvent.bounds);
    }
  }
  const isOnPage = (points) => {
    for (let i=0; i<points.length; i++){
      let point = points[i];
      if(itemMap.hasOwnProperty(point.pointId)){
        return true;
      }
    }
    return false;
  };

  const isSelected = (points) => {
    for (let i=0; i<points.length; i++){
      let point = points[i];
      if(selectedIds.find(id => id === point.pointId)){
        return true;
      }
    }
    return false;
  };

  return (<>
    <GoogleMapReact
      ref={m => map.current = m}
      bootstrapURLKeys={{key: GOOGLE_MAP_API_KEY}}
      options={props.options}
      hoverDistance={props.hoverDistance}
      center={props.mapProps.center}
      zoom={props.mapProps.zoom}
      onChange={boundsChange}
      onChildMouseEnter={props.onChildMouseEnter}
      onChildMouseLeave={props.onChildMouseLeave}
    >
      {
        props.clusters.map((markerProps) => {
          return (markerProps.numPoints === 1
            ? <SimpleMarker key={markerProps.markerId} {...markerProps} openFileDialog={props.openFileDialog} zoom={props.mapProps.zoom} setMapProps={props.setMapProps}
                isSelected={isSelected(markerProps.points)}
                onPage={isOnPage(markerProps.points)} />
            : <ClusterMarker key={markerProps.markerId} {...markerProps} zoom={props.mapProps.zoom} setMapProps={props.setMapProps}
               isSelected={isSelected(markerProps.points)}
               onPage={isOnPage(markerProps.points)} />)
        })
      }
      {
        props.clustersHidden.map((markerProps) => {
          return (markerProps.numPoints === 1
            ? <SimpleMarker key={markerProps.markerId} {...markerProps} openFileDialog={props.openFileDialog} zoom={props.mapProps.zoom} setMapProps={props.setMapProps}
                            isSelected={isSelected(markerProps.points)}
                            onPage={isOnPage(markerProps.points)} />
            : <ClusterMarker key={markerProps.markerId} {...markerProps} zoom={props.mapProps.zoom} setMapProps={props.setMapProps}
                             isSelected={isSelected(markerProps.points)}
                             onPage={isOnPage(markerProps.points)} />)
        })
      }
    </GoogleMapReact>
    </>
  )
}

const mapStateToProps = state => {
  return {
    mindfile: state.mindfile,
    authenticityToken: state.auth.authenticity_token,
  };
};

export const mapView = compose(
  connect(mapStateToProps),
  withGoogleMaps,
  defaultProps({
    clusterRadius: 60,
    hoverDistance: 30,
    options: {
      minZoom: 1,
      maxZoom: 20,
    },
  }),
  withState('hoveredMarkerId', 'setHoveredMarkerId', -1),
  withProps(({ mindfile }) => ({
    initialCenter: {
      lat: mindfile.location?.latitude || 39.9526,
      lng: mindfile.location?.longitude || -75.1652,
    },
  })),
  withState('mapProps', 'setMapProps', ({ initialCenter }) => ({
    center: initialCenter,
    zoom: 3,
  })),
  withHandlers({
    onChange: ({ setMapProps }) => ({ center, zoom, bounds }) => {
      setMapProps({ center, zoom, bounds });
    },
    onChildMouseEnter: ({ setHoveredMarkerId }) => (hoverKey, { markerId }) => {
      setHoveredMarkerId(markerId);
    },
    onChildMouseLeave: ({ setHoveredMarkerId }) => (/* hoverKey, childProps */) => {
      setHoveredMarkerId(-1);
    },
  }),

  // precalculate clusters if markers data has changed
  withPropsOnChange(
    ['markers', 'markersHidden'],
    ({ markers = [], markersHidden = [], clusterRadius, options: { minZoom, maxZoom } }) => ({
      getCluster: supercluster(markers, {
        minZoom, // min zoom to generate clusters on
        maxZoom, // max zoom level to cluster the points on
        radius: clusterRadius, // cluster radius in pixels
      }),
      getClusterHidden: supercluster(markersHidden, {
        minZoom,
        maxZoom,
        radius: clusterRadius,
      }),
    })
  ),
  // get clusters specific for current bounds and zoom
  withPropsOnChange(
    ['mapProps', 'getCluster', 'markers', 'getClusterHidden', 'markersHidden'],
    ({ mapProps, getCluster, getClusterHidden}) => ({
      clusters: mapProps.bounds ? getCluster(mapProps).map(({ wx, wy, numPoints, points }) => {
        return ({
          lat: wy,
          lng: wx,
          text: numPoints,
          numPoints,
          pointId: points[0].pointId,
          points: points,
          markerId: `${numPoints}_${points[0].pointId}`,
        })
      }) : [],
      clustersHidden: mapProps.bounds ? getClusterHidden(mapProps).map(({ wx, wy, numPoints, points }) => ({
        lat: wy,
        lng: wx,
        text: numPoints,
        numPoints,
        pointId: points[0].pointId,
        points: points,
        markerId: `${numPoints}_${points[0].pointId}`,
      })) : [],
    }),
  ),
  withPropsOnChange(
    ['clusters', 'hoveredMarkerId'],
    ({ clusters, hoveredMarkerId }) => ({
      clusters: clusters
        .map((cluster) => ({
          hovered: cluster.markerId === hoveredMarkerId,
          ...cluster,
        })),
    }),
  ),
);

export default connect(mapStateToProps)(mapView(GoogleMap));
